module.exports = __webpack_public_path__ + "img/je.je61157f3.svg";